import "react-toastify/dist/ReactToastify.css";
import { ActiveIcon, StyledIcon } from "../MuiDataTableTheme/MuiDataTableTheme";
import { ExpandButton }from "mui-datatables";
import { colors } from "@mui/material";


 const PrintIcon = () => {
  return <StyledIcon icon="fluent:print-32-regular" />;
};

 const DownloadIcon = () => {
  return <StyledIcon icon="simple-icons:googlesheets" />;
};
 const ViewColumnIcon = () => {
  return <StyledIcon icon="majesticons:view-columns" />;
};



export const components = {
    icons: {
      PrintIcon,
      DownloadIcon,
      ViewColumnIcon,
    },
    /* ExpandButton: function(props) {
      if (props.dataIndex === 3 || props.dataIndex === 4) return <div style={{ width: '24px' }} />;
      return <ExpandButton {...props} />;
    }, */
  };

  export const PrintButtonIcon = ()=>{
   return <StyledIcon icon="fluent:print-32-regular" />
  }

  export const FilterButtonIcon = ()=>{
    return <StyledIcon  icon="ant-design:filter-filled"/>
  }

  export const ActiveFilterButtonIcon = ()=>{
    return <ActiveIcon  icon="ant-design:filter-filled"/>
  }